module.exports = __webpack_public_path__ + "static/media/icon-edit-profile.7e8da662.svg";